import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./MeetingProcess.css";

const MeetingProcess = () => {
  return (
    <>
      <div className="container meeting-process">
        <div className="row">
          <div className="col-md-12">
            <h1 className="headings text-center">
              <span>Our </span>Event Planning Process
            </h1>
          </div>
          <div className="row mt-xxl-5 mt-2 ps-5">
            <div className="d-flex flex-column justify-content-center flex-lg-row">
              <div className="col-lg-6 col-md-12 col-12 d-flex flex-md-row flex-column  pe-0 frame-parent-div">
                <div className="frame1 mb-3 mb-md-0">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <LazyLoadImage
                      src="https://blueberrywebsites.azureedge.net/bbt/images/image%20312.png"
                      alt=""
                      className="processimg"
                      loading="lazy"
                    />
                    <p className="head-process mt-lg-3 mt-md-4 mt-4">
                      Consultation
                    </p>
                    <p className="process-txt">
                      We begin by learning your goals, budget, and vision to
                      create a customized event plan catered to your needs.
                    </p>
                  </div>
                </div>
                <div className="frame1 frame2 ">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <LazyLoadImage
                      src="https://blueberrywebsites.azureedge.net/bbt/images/image%20313.png"
                      alt=""
                      className="processimg"
                      loading="lazy"
                    />
                    <p className="head-process mt-4 pt-xxl-2">Planning</p>
                    <p className="process-txt">
                      After collecting insights, our team designs a detailed
                      event strategy, covering everything from venue selection
                      to creative ideas.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-12 d-flex mt-3 mt-md-3 mt-lg-0 flex-md-row flex-column ps-0 frame-parent-div">
                <div className="frame1 frame2 mb-3 mb-md-0">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <LazyLoadImage
                      src="https://blueberrywebsites.azureedge.net/bbt/images/image%20314.png"
                      alt=""
                      className="processimg"
                      loading="lazy"
                    />
                    <p className="head-process mt-lg-4 mt-md-4 mt-4 pt-xxl-2">
                      Execution
                    </p>
                    <p className="process-txt">
                      Our team takes charge of all logistics, vendor
                      coordination, and on-site operations to ensure flawless
                      execution of your event.
                    </p>
                  </div>
                </div>
                <div className="frame1 frame3">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <LazyLoadImage
                      src="https://blueberrywebsites.azureedge.net/bbt/images/image%20315.png"
                      alt=""
                      className="processimg"
                      loading="lazy"
                    />
                    <p className="head-process mt-lg-4 mt-md-4 mt-4 pt-xxl-2">
                      Follow-Up
                    </p>
                    <p className="process-txt">
                      Post-event, we take pride in giving dedicated support to
                      gather feedback from our clients and evaluate their
                      overall success.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MeetingProcess;
